import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top on every route change (window + dashboard's inner <main> scroller).
// rAF + delayed retries defeat browser scroll-anchoring that restores the old position.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const reset = () => {
      window.scrollTo(0, 0);
      const m = document.querySelector("main");
      if (m) m.scrollTop = 0;
    };
    reset();
    requestAnimationFrame(reset);
    const t = setTimeout(reset, 100);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}
